import { ListRecommendedProductsRequest } from '../rpc/model/squareup/solidshop/v2/service/products/list_recommended_products';
import shopClient from '../clients/shop';

export const listRecommendedProducts = ({
  productKeys,
  locale,
  storeCode,
  limit,
}) => {
  const rpcRequest = ListRecommendedProductsRequest.create({
    productKeys,
    locale,
    storeCode,
    limit,
  });

  return shopClient.listRecommendedProducts(rpcRequest);
};
